import React from 'react';

import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

import {
  RelatedCAPA,
  CarrDescription,
  Cause, CarrDate
} from 'components/form/fields';

const CorrectiveAction = () => {

  return (
    <>
      <Row className={'mb-2'}>
        <Col>
          <Row className={'mb-2'}>
            <Col>
              <h5>Corrective Action Report (CAR)
                <hr />
              </h5>
            </Col>
          </Row>
          <Row className={'mb-2'}>
            <Col md>
              <CarrDate />
              <Cause />
            </Col>
            <Col md>
              <RelatedCAPA />
              <CarrDescription />
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  )
}

export { CorrectiveAction };
